import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/** Refund and delivery policy links, shown under every price list. */
export default function PolicyLinks() {
  const { t } = useTranslation();
  return (
    <p className="mt-2 text-center text-xs text-foreground-500 flex items-center justify-center gap-3">
      <Link to="/refund-policy" className="text-primary-600 hover:underline">
        {t("common.legal.refundPolicy")}
      </Link>
      <span aria-hidden="true">·</span>
      <Link to="/delivery-policy" className="text-primary-600 hover:underline">
        {t("common.legal.deliveryPolicy")}
      </Link>
    </p>
  );
}
